import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar, Toolbar, Button, Box, Typography, IconButton,
  Drawer, List, ListItem, ListItemButton, ListItemText, useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';

const LayoutAdminHeader = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuLinks = [
    { label: 'Registrations', to: '/GetAllRegistrations' },
    { label: 'Discount', to: '/Discount' },
    { label: 'Services', to: '/ServiceList' },
    { label: 'Order', to: '/OrderList' },
    { label: 'GST', to: '/GSTPercentageList' },
    { label: 'Sale Invoice', to: '/GetAllSaleInvoices' },
    { label: 'Purchase Invoice', to: '/GetAllPurchaseInvoices' },
    { label: 'Report', to: '/AdminReport' },
    { label: 'Change Password', to: '/ChangePassword' },
    {
      label: 'Logout',
      to: '/',
      icon: <LogoutIcon sx={{ fontSize: 18, color: '#ffffff' }} />
    }
  ];

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          px: 2,
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              textDecoration: 'none',
              color: '#004080',
              fontWeight: 'bold',
              fontSize: '1.8rem',
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: '0.5px',
            }}
          >
            EASUP
          </Typography>

          {!isMobile && (
           <Typography
  variant="body1"
  sx={{
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    color: '#004080',
  }}
>
  Welcome to:{' '}
  <Box component="span" sx={{ fontWeight: 'bold' }}>
    Admin
  </Box>
</Typography>

          )}

          {!isMobile ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {menuLinks.map((item, index) => {
                const isLogout = item.label === 'Logout';
                return (
                  <Button
                    key={index}
                    component={Link}
                    to={item.to}
                    sx={{
                      color: isLogout ? '#ffffff' : '#333333',
                      backgroundColor: isLogout ? '#004080' : 'transparent',
                      fontWeight: isLogout ? 'bold' : 500,
                      fontSize: '1rem',
                      fontFamily: "'Poppins', sans-serif",
                      textTransform: 'none',
                      mx: 1.5,
                      borderRadius: isLogout ? '20px' : '0',
                      px: isLogout ? 2 : undefined,
                      py: isLogout ? 1 : undefined,
                      '&:hover': {
                        color: isLogout ? '#ffffff' : '#004080',
                        backgroundColor: isLogout ? '#003366' : 'transparent',
                      },
                      display: 'flex',
                      alignItems: 'center',
                      gap: isLogout ? 1 : 0,
                    }}
                  >
                    {isLogout && item.icon}
                    {item.label}
                  </Button>
                );
              })}
            </Box>
          ) : (
            <>
              <IconButton onClick={toggleDrawer(true)} edge="end">
                <MenuIcon sx={{ color: '#004080' }} />
              </IconButton>
              <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 250, p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ color: '#004080' }}>
                      Menu
                    </Typography>
                    <IconButton onClick={toggleDrawer(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <List>
                    {menuLinks.map((item, index) => (
                      <ListItem key={index} disablePadding>
                        <ListItemButton
                          component={Link}
                          to={item.to}
                          onClick={toggleDrawer(false)}
                        >
                          <ListItemText
                            primary={
                              item.label === 'Logout' ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <LogoutIcon sx={{ fontSize: 18, color: '#004080' }} />
                                  {item.label}
                                </Box>
                              ) : (
                                item.label
                              )
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default LayoutAdminHeader;
